import { createReducer } from 'typesafe-actions';
import { BasketItem } from '../types';
import { BASKET_SET, BASKET_UPDATE_ITEM } from './actions';

export const basket = createReducer<BasketItem[] | null>(null)
  .handleAction(BASKET_SET, (state, { payload }) => payload)
  .handleAction(BASKET_UPDATE_ITEM, (state, { payload }) => {
    const res = state instanceof Array ? [...state] : [];

    const itemIdx = res.findIndex(({ code }) => code === payload.code);
    if (itemIdx >= 0) {
      res.splice(itemIdx, 1);
    }

    if (payload.quantity > 0) {
      res.push(payload);
    }

    return res;
  });
